import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Null-render tracker. Fires one page-view per SPA route change. Must live
 * inside the Router (it uses useLocation). React StrictMode double-invokes
 * effects in dev, so we dedupe on the resolved path.
 */
export function VisitorTracker() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    trackPageview(location.pathname);
  }, [location.pathname, location.search]);

  return null;
}
